import { z } from 'zod'
import { Model } from './architecture'

export const GeoCoordinateValidation = z.object({
  latitude: z.number({ required_error: '[GeoCoordinate] latitude is required' }).min(-90).max(90),
  longitude: z
    .number({ required_error: '[GeoCoordinate] longitude is required' })
    .min(-180)
    .max(180),
})

export class GeoCoordinate extends Model {
  static create({ latitude, longitude }: z.infer<typeof GeoCoordinateValidation>) {
    GeoCoordinateValidation.parse({ latitude, longitude })
    return new GeoCoordinate(latitude, longitude)
  }

  constructor(
    private readonly _latitude: number,
    private readonly _longitude: number
  ) {
    super()
  }

  get latitude() { return this._latitude } // prettier-ignore

  get longitude() { return this._longitude } // prettier-ignore

  toJSON() {
    return { latitude: this._latitude, longitude: this._longitude }
  }
}
